<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Report Sales by Period</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
              <div class="form-group col-3">
                <label for="subject">Start Date</label>
                <flat-pickr class="form-control" v-model="reportSalesPeriod.startDate" ></flat-pickr>
              </div>
              <div class="form-group col-3">
                <label for="subject">To Date</label>
                <flat-pickr class="form-control" v-model="reportSalesPeriod.toDate"></flat-pickr>
              </div>
              <div class="form-group col-3">
                <label for="subject">Customer</label>
                <app-lookup-field :model="reportSalesPeriod" :element="customerLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
        </div>
        <br /><br />
        <button type="button" class="btn btn-outline-success" @click="print">Print <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { reportSalesPeriod } from '../../models/report'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import download from 'js-file-download';

export default {
    components: {
      AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
      return {
        reportSalesPeriod: {...reportSalesPeriod},
        customerLookup: {
                id: 'customer',
                title: 'Customer',
                type: 'form',
                apiUrl: 'customer-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Customer',
                        width: 12,
                        column: 'customerName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'customerId'
                    },
                    {
                        from: 'name',
                        to: 'customerName'
                    },
                ]
        },
      }
    },
    async created() {

    },
    methods: {
      async print() {
      const rptApi = api('print/report-sales-period')
      const query = { 
        params: {
          startDate: this.reportSalesPeriod.startDate,
          toDate: this.reportSalesPeriod.toDate,
          customerId: this.reportSalesPeriod.customerId
        }
      }
      const excelFile = await rptApi.getFileWithQuery(query)
      download(excelFile, 'Report-Sales.xlsx')
    },
    cancel() {
      this.$router.go(-1)
    },
    finishLookup(data) {
        const currentSalesPeriod = this.reportSalesPeriod
        this.reportSalesPeriod = {
            ...currentSalesPeriod,
            ...data
        }
    },
    finishUpload(data) {
        const currentSalesPeriod = this.reportSalesPeriod
        this.reportSalesPeriod = {
            ...currentSalesPeriod,
            ...data
        }
    },
    }
}
</script>